module.exports = __webpack_public_path__ + "static/media/trash-icon.104194a5.svg";